/**
 * @Author: Zero
 * @Date: 2023-05-23 21:39:01
 * @Explain: 标题模块
 */
import React, { ReactNode } from 'react';

interface TitleBlockPropsTyes {
  /** 标题 */
  title?: string | ReactNode;
  /** 标题右侧内容 */
  titleRight?: string | ReactNode;
  /** 描述 */
  desc?: string | ReactNode;
  /** 描述右侧内容 */
  descRight?: string | ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 标题自定义类名 */
  titleClassName?: string;
  /** 描述自定义类名 */
  descClassName?: string;
  /** 样式 */
  style?: any;
}
const TitleBlock = (props: TitleBlockPropsTyes) => {
  const {
    title = '',
    desc = '',
    descRight = null,
    className = '',
    titleRight = null,
    titleClassName = '',
    descClassName = '',
    style = {},
  } = props;
  return (
    <div className={`contact-manage-title-block ${className}`} style={style}>
      {title ? (
        <div className="flex-block flex-justify-between">
          <div className={`contact-manage-title ${titleClassName}`}>
            {title}
          </div>
          <div>{titleRight}</div>
        </div>
      ) : null}
      {desc ? (
        <div className="flex-block flex-justify-between">
          <div className={`contact-manage-desc ${descClassName}`}>{desc}</div>
          <>{descRight}</>
        </div>
      ) : null}
    </div>
  );
};
export default TitleBlock;
